<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>UoM Groups</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" small to="/inventory/new-uom-group">
          <v-icon left dark>mdi-plus</v-icon>New
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Search"
              v-model="search"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-data-table
              :loading="loading"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="uomGroups"
              :search="search"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-show="item.UgpName !== 'Manual'"
                  text
                  :to="`/uom-group/definition/${item.id}`"
                  color="accent"
                >
                  <v-icon>mdi-pen-plus</v-icon>Group Definition
                </v-btn>
              </template>

              <!-- action template -->
              <template v-slot:item.deleteOugp="{ item }">
                <v-btn color="red" @click="openDeleteModal(item)" text icon
                  ><v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <template v-slot:item.edit="{ item }">
                <v-btn color="primary" @click="openEditModal(item)" text icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <!-- Product delete dialog modal-->
            <v-dialog v-model="deleteDialog" max-width="650px">
              <v-card>
                <v-toolbar dense color="red" dark>
                  <v-toolbar-title> Delete Uom Group </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="deleteDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid>
                    <v-row class="text--primary subtitle-2">
                      <v-col cols="12">
                        Are you sure you want to delete this uom Group?
                      </v-col>
                      <v-col cols="12">
                        <span style="font-size: 20px; color: red">{{
                          ougpItem.UgpName
                        }}</span>
                      </v-col>

                      <v-col cols="12">
                        <v-btn
                          color="red"
                          dark
                          :loading="loader"
                          @click="deleteOugp"
                          >Yes, Delete</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of modal-->

            <!-- Edit Ougp dialog modal-->
            <v-dialog v-model="editDialog" max-width="650px">
              <v-card>
                <v-toolbar dense color="red" dark>
                  <v-toolbar-title> Edit Uom Group </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="editDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid>
                    <v-row class="text--primary subtitle-2">
                      <v-col cols="12" md="12">
                        <v-text-field
                          label="Name"
                          v-model="ougpItem.UgpName"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>

                      <v-col cols="6">
                        <v-autocomplete
                          name="BaseUom"
                          outlined
                          dense
                          v-model="ougpItem.BaseUom"
                          :items="uom"
                          item-text="UomName"
                          item-value="id"
                          label="Base UoM"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-btn
                          color="primary"
                          dark
                          :loading="loader"
                          @click="updateOugp"
                          >Update</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end of modal-->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- start of group dialog -->
    <v-dialog
      v-model="gdDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="accent">
          <v-toolbar-title>
            <v-btn icon dark @click="gdDialog = false">
              <v-icon dark>mdi-keyboard-backspace</v-icon>
            </v-btn>
            {{ groupItem.UgpName }} - Group Definition
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="gdDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn @click="newGroup" color="primary" small>
                  <v-icon left>mdi-plus</v-icon>New Group Definition
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Alt Qty.</th>
                        <th class="text-left">Alt UoM</th>
                        <th class="text-left">=</th>
                        <th class="text-left">Base Qty.</th>
                        <th class="text-left">Base UoM</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in groupDef" v-bind:key="index">
                        <td>
                          {{ item.AltQty }}
                        </td>
                        <td>
                          {{ item.uomentry.UomName }}
                        </td>
                        <td>=</td>
                        <td>{{ item.BaseQty }}</td>
                        <td>{{ groupItem.ouom.UomName }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <!-- group definition entry modal -->
            <v-dialog width="1050" v-model="defDialog">
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>New Group Definition</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="defDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="3">
                      <v-text-field
                        name="defAltQty"
                        label="Alt Qty."
                        v-model="defItem.AltQty"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-autocomplete
                        name="defUomEntry"
                        v-model="defItem.UomEntry"
                        :items="uom"
                        item-text="UomName"
                        item-value="id"
                        label="Alt UoM"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        name="defBaseQty"
                        label="Base Qty."
                        v-model="defItem.BaseQty"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        name="defBaseUOm"
                        label="Base UoM"
                        v-if="groupItem.ouom"
                        v-model="groupItem.ouom.UomName"
                        readonly
                        filled
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" small @click="createugp1">
                        <v-icon left>mdi-content-save</v-icon> Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- end -->
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of -->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    uomGroups: [],
    editDialog: false,
    loader: false,
    deleteDialog: false,
    gdDialog: false,
    defDialog: false,
    ougpItem: {},
    defItem: {},
    groupItem: {},
    groupDef: [],
    uom: [],
    definitions: [],
    headers: [
      { text: "UoM Group Name", value: "UgpName" },
      { text: "Base UoM", value: "ouom.UomName" },
      { text: "Actions", value: "actions", sortable: false },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "deleteOugp" },
    ],
  }),
  methods: {
    openDeleteModal(data) {
      this.ougpItem = data;
      this.deleteDialog = true;
    },
    openEditModal(data) {
      this.ougpItem = data;
      this.editDialog = true;
    },
    groupDefinition(data) {
      this.groupItem = data;
      this.groupDef = data.groupDef;
      this.gdDialog = true;
    },
    newGroup() {
      this.defDialog = true;
    },
    createugp1() {
      const data = {
        UgpEntry: this.groupItem.id,
        UomEntry: this.defItem.UomEntry,
        AltQty: this.defItem.AltQty,
        BaseQty: this.defItem.BaseQty,
      };
      const url = "/createugp1";
      this.$store
        .dispatch("post", { url, data })
        .then(() => {
          location.reload();
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    updateOugp() {
      const data = {
        id: this.ougpItem.id,
        UgpName: this.ougpItem.UgpName,
        BaseUom: this.ougpItem.BaseUom,
      };
      const url = "/update/ougp";
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(() => {
          location.reload();
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUom() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/oums`)
        .then((res) => {
          self.uom = res.ResponseData;
          self.loading = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUomGroups() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/ougp`)
        .then((res) => {
          self.uomGroups = res.ResponseData;
          self.loading = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    deleteOugp() {
      const data = this.ougpItem;
      const url = `/delete/ougp/${this.ougpItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getUomGroups();
    this.getUom();
  },
};
</script>